import { Component, OnInit, Input } from '@angular/core';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'app-selector',
    templateUrl: './selector.component.html',
    styleUrls: ['./selector.component.scss'],
    standalone: true,
    imports: [NgStyle]
})
export class SelectorComponent implements OnInit {

    @Input() variant: string = 'text';
    @Input() width: any;
    @Input() height: any;
    @Input() style: any = {};

    constructor() {}

    ngOnInit() {
        this.style = {
            ...this.style,
            height: this.height,
            width: this.width
        };
    }

}
